import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import { useBehavioralTrackingProps } from '../../core/hooks/useBehavioralTrackingProps.js';
import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import type { DataTestId } from '../../core/types/data-props.js';
import type { StylingProps } from '../../core/types/styling-props.js';
import * as styles from './InlineButton.sty.js';

/**
 * Accepted properties for the InlineButton Suffix.
 * @public
 */
export interface InlineButtonSuffixProps
  extends StylingProps, DataTestId, BehaviorTrackingProps {
  children: ReactNode;
}

export const Suffix = forwardRef<HTMLSpanElement, InlineButtonSuffixProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
      ...remainingProps
    }: InlineButtonSuffixProps = props;

    const [behavioralTrackingProps] =
      useBehavioralTrackingProps(remainingProps);

    return (
      <span
        ref={forwardedRef}
        className={clsx(styles.suffixSlot, consumerClassName)}
        style={consumerStyle}
        data-testid={dataTestId}
        {...behavioralTrackingProps}
      >
        {children}
      </span>
    );
  },
);

(Suffix as typeof Suffix & { displayName: string }).displayName =
  'InlineButton.Suffix';
